import { API_BASE, apiErrorHandler } from '../api'
import { objectToSnakeCase } from '../utils'
import axios from 'axios'
import Auth from '../auth'

export const DOCUMENT_ENDPOINT = `${API_BASE}documents/`

export default class DocumentAPI {
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `UserAPI`.
   *
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new DocumentAPI(cls)
  }

  create(doc) {
    let formData = new FormData()
    formData.append('file', doc.file, doc.filename)
    formData.append('filename', doc.filename)
    if (doc.event) {
      formData.append('event', doc.event)
    } else if (doc.expense) {
      formData.append('expense', doc.expense)
    } else if (doc.stipend) {
      formData.append('stipend', doc.stipend)
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(DOCUMENT_ENDPOINT, formData, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Create Document API error' }))
  }

  delete(doc) {
    const url = `${DOCUMENT_ENDPOINT}${doc.id}/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .delete(url, options)
      .catch(apiErrorHandler({ apiName: 'Delete Document API error' }))
  }
}
